import { supabase } from "@/integrations/supabase/client";

export type CpdSource = 
  | 'simulation_completion' 
  | 'goal_achieved' 
  | 'badge_earned' 
  | 'perfect_score'
  | 'coaching_completion'
  | 'coaching_excellence'
  | 'coaching_exceptional';

export async function awardCpdPoints(
  userId: string,
  points: number,
  source: CpdSource,
  sourceId?: string,
  description?: string
) {
  const { error } = await supabase
    .from('user_cpd_points')
    .insert({
      user_id: userId,
      points,
      source,
      source_id: sourceId,
      description,
    });

  if (!error) {
    // Log activity
    await supabase
      .from('user_activity_log')
      .insert({
        user_id: userId,
        activity_type: 'cpd_earned',
        title: `+${points} CPD Points`,
        description: description || `Earned ${points} CPD points`,
        metadata: { points, source },
      });
  }

  return { error };
}

export async function getTotalCpdPoints(userId: string): Promise<number> {
  const { data } = await supabase
    .from('user_cpd_points')
    .select('points')
    .eq('user_id', userId);

  return data?.reduce((sum, record) => sum + record.points, 0) || 0;
}
